//DEFAULTS
import "core-js/stable";
import "regenerator-runtime/runtime";

import site from './js/site'
import global from './js/global'
import charts from './js/charts'
import mobileNav from './js/mobileNav'
import Lenis from 'lenis';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

try {
  gsap.registerPlugin(ScrollTrigger);
  window.gsap = gsap;
  window.ScrollTrigger = ScrollTrigger;
} catch (_) { /* no-op */
}

$(document).ready(function () {
  // Initialize smooth scrolling (Lenis) and expose for modules
  try {
    const lenis = new Lenis({
      smoothWheel: true,
      smoothTouch: false,
    });
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  } catch (e) { /* ignore if not available */
  }

  site.init()
  global.init()
  charts.init()
  mobileNav.init()

})
